"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steingroesse = void 0;
var Steingroesse;
(function (Steingroesse) {
    Steingroesse["stein0005"] = "stein0005";
    Steingroesse["stein001"] = "stein001";
    Steingroesse["stein0015"] = "stein0015";
    Steingroesse["stein002"] = "stein002";
    Steingroesse["stein0025"] = "stein0025";
    Steingroesse["stein003"] = "stein003";
    Steingroesse["stein004"] = "stein004";
    Steingroesse["stein005"] = "stein005";
    Steingroesse["stein006"] = "stein006";
    Steingroesse["stein007"] = "stein007";
    Steingroesse["stein008"] = "stein008";
    Steingroesse["stein009"] = "stein009";
    Steingroesse["stein01"] = "stein01";
    Steingroesse["stein011"] = "stein011";
    Steingroesse["stein012"] = "stein012";
    Steingroesse["stein013"] = "stein013";
    Steingroesse["stein014"] = "stein014";
    Steingroesse["stein015"] = "stein015";
    Steingroesse["stein016"] = "stein016";
    Steingroesse["stein017"] = "stein017";
    Steingroesse["stein018"] = "stein018";
    Steingroesse["stein019"] = "stein019";
    Steingroesse["stein02"] = "stein02";
    Steingroesse["stein025"] = "stein025";
    Steingroesse["stein03"] = "stein03";
    Steingroesse["stein035"] = "stein035";
    Steingroesse["stein04"] = "stein04";
    Steingroesse["stein045"] = "stein045";
    Steingroesse["stein05"] = "stein05";
    Steingroesse["stein055"] = "stein055";
    Steingroesse["stein06"] = "stein06";
    Steingroesse["stein065"] = "stein065";
    Steingroesse["stein07"] = "stein07";
    Steingroesse["stein075"] = "stein075";
    Steingroesse["stein08"] = "stein08";
    Steingroesse["stein085"] = "stein085";
    Steingroesse["stein09"] = "stein09";
    Steingroesse["stein095"] = "stein095";
    Steingroesse["stein1"] = "stein1";
})(Steingroesse = exports.Steingroesse || (exports.Steingroesse = {}));
//# sourceMappingURL=Steingroesse.js.map